// extracted by mini-css-extract-plugin
module.exports = {"Backdrop":"Backdrop__Backdrop__[hash_base64-5]"};